var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-map")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _vm.$_can("companies.update")
                  ? _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: { click: _vm.save }
                        },
                        [
                          _vm._v("\n          Save\n          "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", {
                attrs: { type: "create", "saved-settings": _vm.savedSettings }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("companies.update")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary ld-ext-right ml-5",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: {
                              type: "button",
                              disabled: _vm.buttonDisabled
                            },
                            on: { click: _vm.save }
                          },
                          [
                            _vm._v("\n          Save\n          "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-5" }, [
        _c(
          "div",
          { staticClass: "col-6 move-sizes" },
          [
            _c("div", { staticClass: "l-header-2" }, [_vm._v("Move sizes")]),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "move_sizes" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "move-sizes-wrap border rounded-top user-role" },
              _vm._l(_vm.moveSizesAll, function(size, index) {
                return _c("div", { key: size.id }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("div", { staticClass: "check-field" }, [
                        _c(
                          "label",
                          {
                            class: [
                              {
                                "check-open": _vm.move_sizes.find(function(el) {
                                  return el.id === size.id
                                })
                              },
                              {
                                disabled: !_vm.$_can(
                                  "companies.move-size.update"
                                )
                              }
                            ],
                            attrs: { for: "move_size-" + index }
                          },
                          [
                            _c("span", { staticClass: "checkmark" }),
                            _vm._v(_vm._s(size.name) + "\n                  "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.move_sizes,
                                  expression: "move_sizes"
                                }
                              ],
                              staticClass: "btn-check",
                              attrs: {
                                type: "checkbox",
                                id: "move_size-" + index
                              },
                              domProps: {
                                value: size,
                                checked: Array.isArray(_vm.move_sizes)
                                  ? _vm._i(_vm.move_sizes, size) > -1
                                  : _vm.move_sizes
                              },
                              on: {
                                click: function($event) {
                                  _vm.clearError($event)
                                },
                                change: function($event) {
                                  var $$a = _vm.move_sizes,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = size,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.move_sizes = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.move_sizes = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.move_sizes = $$c
                                  }
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "check-field" }, [
                        _c(
                          "label",
                          {
                            class: [
                              {
                                "check-open":
                                  _vm.move_sizes.find(function(el) {
                                    return el.id === size.id
                                  }) &&
                                  _vm.move_sizes.find(function(el) {
                                    return el.id === size.id
                                  }).small_job === 1
                              },
                              {
                                disabled:
                                  !_vm.$_can("companies.move-size.update") ||
                                  !_vm.move_sizes.find(function(el) {
                                    return el.id === size.id
                                  })
                              }
                            ],
                            attrs: { for: "small_job-" + index },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.changeSmallJob(
                                  _vm.move_sizes.find(function(el) {
                                    return el.id === size.id
                                  })
                                )
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "checkmark" }),
                            _vm._v("Small job\n                  "),
                            _c("input", {
                              staticClass: "btn-check",
                              attrs: {
                                type: "checkbox",
                                id: "small_job-" + index
                              },
                              on: {
                                click: function($event) {
                                  _vm.clearError($event)
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$_can("companies.arrival-windows.index")
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "l-header-2" }, [
                  _vm._v("Arrival windows")
                ]),
                _vm._v(" "),
                _vm._l(_vm.arrival_windows, function(arrival_window, index) {
                  return _c(
                    "div",
                    { key: arrival_window.id, staticClass: "row mb-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-3 pr-1" },
                        [
                          _c("div", { staticClass: "select-wrap" }, [
                            _c("label", [_vm._v("Name")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: arrival_window.name,
                                  expression: "arrival_window.name"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                disabled: !_vm.$_can(
                                  "companies.arrival-windows.update"
                                )
                              },
                              domProps: { value: arrival_window.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    arrival_window,
                                    "name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: {
                              errors: _vm.errors,
                              field: index + ".name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3 px-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-wrap" },
                            [
                              _c("label", [_vm._v("From")]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.arrival_windows_list,
                                  "return-value": "",
                                  placeholder: "Select Arrival Window",
                                  disabled: !_vm.$_can(
                                    "companies.arrival-windows.update"
                                  )
                                },
                                model: {
                                  value: arrival_window.arrival_from,
                                  callback: function($$v) {
                                    _vm.$set(
                                      arrival_window,
                                      "arrival_from",
                                      $$v
                                    )
                                  },
                                  expression: "arrival_window.arrival_from"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: {
                              errors: _vm.errors,
                              field: index + ".from"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3 pl-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-wrap" },
                            [
                              _c("label", [_vm._v("To")]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.arrival_windows_list,
                                  "return-value": "",
                                  placeholder: "Select Arrival Window",
                                  disabled: !_vm.$_can(
                                    "companies.arrival-windows.update"
                                  )
                                },
                                model: {
                                  value: arrival_window.arrival_to,
                                  callback: function($$v) {
                                    _vm.$set(arrival_window, "arrival_to", $$v)
                                  },
                                  expression: "arrival_window.arrival_to"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: index + ".to" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$_can("companies.arrival-windows.destroy")
                        ? _c("div", { staticClass: "col-3" }, [
                            _vm.arrival_windows.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-clear mt-3",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.removeArrivalWindow(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mod-icon-clear"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.$_can("companies.arrival-windows.store")
                  ? _c("div", { staticClass: "row mt-3" }, [
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn add-button",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.addArrivalWindow()
                              }
                            }
                          },
                          [_vm._m(0), _vm._v("Add Arrival Window\n          ")]
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-5" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "l-header-2" }, [_vm._v("Booking options")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "booking-wrap move-sizes-wrap border rounded-top user-role"
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "check-field" }, [
                  _c(
                    "label",
                    {
                      class: [
                        _vm.company.booking_phone
                          ? "check-open"
                          : "check-closed"
                      ],
                      attrs: { for: "book_phone" }
                    },
                    [
                      _c("span", { staticClass: "checkmark" }),
                      _vm._v("Book through phone\n              "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.booking_phone,
                            expression: "company.booking_phone"
                          }
                        ],
                        staticClass: "btn-check",
                        attrs: { type: "checkbox", id: "book_phone" },
                        domProps: {
                          checked: Array.isArray(_vm.company.booking_phone)
                            ? _vm._i(_vm.company.booking_phone, null) > -1
                            : _vm.company.booking_phone
                        },
                        on: {
                          click: function($event) {
                            _vm.clearError($event)
                          },
                          change: function($event) {
                            var $$a = _vm.company.booking_phone,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.company,
                                    "booking_phone",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.company,
                                    "booking_phone",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.company, "booking_phone", $$c)
                            }
                          }
                        }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "check-field" }, [
                  _c(
                    "label",
                    {
                      class: [
                        _vm.company.booking_send_offers
                          ? "check-open"
                          : "check-closed"
                      ],
                      attrs: { for: "book_offer" }
                    },
                    [
                      _c("span", { staticClass: "checkmark" }),
                      _vm._v("Send offers to customer\n              "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.booking_send_offers,
                            expression: "company.booking_send_offers"
                          }
                        ],
                        staticClass: "btn-check",
                        attrs: { type: "checkbox", id: "book_offer" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.company.booking_send_offers
                          )
                            ? _vm._i(_vm.company.booking_send_offers, null) > -1
                            : _vm.company.booking_send_offers
                        },
                        on: {
                          click: function($event) {
                            _vm.clearError($event)
                          },
                          change: function($event) {
                            var $$a = _vm.company.booking_send_offers,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.company,
                                    "booking_send_offers",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.company,
                                    "booking_send_offers",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.company, "booking_send_offers", $$c)
                            }
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _vm.$_can("companies.payment-profiles.index")
          ? _c("div", { staticClass: "col-4" }, [
              _c("div", { staticClass: "l-header-2" }, [
                _vm._v("Payment gateway")
              ]),
              _vm._v(" "),
              _vm.company.payment_gateway !== undefined
                ? _c(
                    "div",
                    {
                      staticClass:
                        "py-3 px-2 pointer d-flex align-items-center payment-wrap",
                      on: {
                        click: function($event) {
                          _vm.$_can("companies.payment-profiles.update") &&
                            _vm.openGatewayModal("edit")
                        }
                      }
                    },
                    [
                      _vm.paymentProfile.payment_gateway_id === 1
                        ? _c("span", { staticClass: "mod-icon-stripe" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.paymentProfile.payment_gateway_id === 2
                        ? _c("span", { staticClass: "mod-icon-authorize" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "payment-name" }, [
                        _vm._v(_vm._s(_vm.company.payment_gateway)),
                        _c("br"),
                        _c("small", [_vm._v(_vm._s(_vm.paymentProfile.name))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "payment-delete pointer ml-auto",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.removePaymentGateway($event)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ]
                  )
                : _c("div", [
                    _vm.$_can("companies.payment-profiles.store")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn add-button",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.openGatewayModal("edit")
                              }
                            }
                          },
                          [
                            _vm._m(1),
                            _vm._v(
                              "\n          Select merchant account\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showSelectGatewayModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Add payment profile")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("label", { staticClass: "m-label" }, [
                            _vm._v("Select payment gateway")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "select-wrap mb-2" },
                            [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Payment processor")
                              ]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.paymentGateways,
                                  placeholder: "Select Payment Processor"
                                },
                                on: { input: _vm.loadPaymentProfiles },
                                model: {
                                  value: _vm.paymentProfile.payment_gateway_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paymentProfile,
                                      "payment_gateway_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paymentProfile.payment_gateway_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: {
                              errors: _vm.errors,
                              field: "payment_gateway_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("label", { staticClass: "m-label" }, [
                            _vm._v("Select profile")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "select-wrap mb-2" },
                            [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Payment profile")
                              ]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.paymentProfiles,
                                  "custom-label": _vm.customLabel,
                                  placeholder: "Select Payment Processor"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.errors.clear("payment_profile_id")
                                  }
                                },
                                model: {
                                  value: _vm.paymentProfile.id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.paymentProfile, "id", $$v)
                                  },
                                  expression: "paymentProfile.id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: {
                              errors: _vm.errors,
                              field: "payment_profile_id"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _vm.$_can("companies.payment-profiles.store")
                          ? _c(
                              "button",
                              {
                                staticClass: "btn add-button",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.openGatewayModal("create")
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _c("span", { staticClass: "mod-icon-add" })
                                ]),
                                _vm._v("Create new\n            ")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary ld-ext-right pull-right",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: {
                              type: "button",
                              disabled: _vm.buttonDisabled
                            },
                            on: { click: _vm.assignPaymentGateway }
                          },
                          [
                            _vm._v("\n              Save\n              "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      ])
                    ])
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "company_id" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateGatewayModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Add new gateway")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-wrap mb-2" },
                            [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Payment processor")
                              ]),
                              _vm._v(" "),
                              _c("simple-select", {
                                attrs: {
                                  options: _vm.paymentGateways,
                                  placeholder: "Select Payment Processor"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.errors.clear("payment_gateway_id")
                                  }
                                },
                                model: {
                                  value:
                                    _vm.newPaymentProfile.payment_gateway_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newPaymentProfile,
                                      "payment_gateway_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "newPaymentProfile.payment_gateway_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: {
                              errors: _vm.errors,
                              field: "payment_gateway_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("div", { staticClass: "select-wrap mb-2" }, [
                            _c("label", { staticClass: "m-label" }, [
                              _vm._v("Name")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newPaymentProfile.name,
                                  expression: "newPaymentProfile.name"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.newPaymentProfile.name },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.newPaymentProfile,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                  function($event) {
                                    _vm.errors.clear("name")
                                  }
                                ]
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "name" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.newPaymentProfile.payment_gateway_id ===
                                    1,
                                  expression:
                                    "newPaymentProfile.payment_gateway_id === 1"
                                }
                              ]
                            },
                            [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Credentials")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-wrap mb-2" }, [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Secret key")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.newPaymentProfile.credentials
                                          .apiKey,
                                      expression:
                                        "newPaymentProfile.credentials.apiKey"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", name: "apiKey" },
                                  domProps: {
                                    value:
                                      _vm.newPaymentProfile.credentials.apiKey
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newPaymentProfile.credentials,
                                          "apiKey",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        _vm.errors.clear("credentials")
                                      }
                                    ]
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-wrap mb-2" }, [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Publishable key")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.newPaymentProfile.credentials
                                          .publicKey,
                                      expression:
                                        "newPaymentProfile.credentials.publicKey"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", name: "publicKey" },
                                  domProps: {
                                    value:
                                      _vm.newPaymentProfile.credentials
                                        .publicKey
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newPaymentProfile.credentials,
                                          "publicKey",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        _vm.errors.clear("credentials")
                                      }
                                    ]
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.newPaymentProfile.payment_gateway_id ===
                                    2,
                                  expression:
                                    "newPaymentProfile.payment_gateway_id === 2"
                                }
                              ]
                            },
                            [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Credentials")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-wrap mb-2" }, [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Client key")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.newPaymentProfile.credentials
                                          .clientKey,
                                      expression:
                                        "newPaymentProfile.credentials.clientKey"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", name: "clientKey" },
                                  domProps: {
                                    value:
                                      _vm.newPaymentProfile.credentials
                                        .clientKey
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newPaymentProfile.credentials,
                                          "clientKey",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        _vm.errors.clear("credentials")
                                      }
                                    ]
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-wrap mb-2" }, [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Login ID")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.newPaymentProfile.credentials
                                          .apiLoginID,
                                      expression:
                                        "newPaymentProfile.credentials.apiLoginID"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", name: "apiLoginID" },
                                  domProps: {
                                    value:
                                      _vm.newPaymentProfile.credentials
                                        .apiLoginID
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newPaymentProfile.credentials,
                                          "apiLoginID",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        _vm.errors.clear("credentials")
                                      }
                                    ]
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-wrap mb-2" }, [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Transaction key")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.newPaymentProfile.credentials
                                          .transactionKey,
                                      expression:
                                        "newPaymentProfile.credentials.transactionKey"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    name: "transactionKey"
                                  },
                                  domProps: {
                                    value:
                                      _vm.newPaymentProfile.credentials
                                        .transactionKey
                                  },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newPaymentProfile.credentials,
                                          "transactionKey",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        _vm.errors.clear("credentials")
                                      }
                                    ]
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "credentials" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary ld-ext-right pull-right",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: {
                              type: "button",
                              disabled: _vm.buttonDisabled
                            },
                            on: { click: _vm.createPaymentGateway }
                          },
                          [
                            _vm._v("\n              Add\n              "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      ])
                    ])
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "company_id" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd8f062c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd8f062c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesSettings.vue
// module id = null
// module chunks = 